export default __webpack_public_path__ + "static/media/Nunito-SemiBold.6a5a212c.ttf";